import script from "./FaqPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FaqPage.vue?vue&type=script&setup=true&lang=js"

import "./FaqPage.vue?vue&type=style&index=0&id=6dbcfede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbcfede"]])

export default __exports__